<script setup lang="ts">
import { PromptService } from '@/services/PromptService.ts';
import { Badge } from '@/components/ui/badge';
import type { PromptConfig } from '@/types/edit/PromptConfig.ts';
import type { SessionId } from '@/types/Session.ts';
import { computed } from 'vue';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { upperFirst } from 'scule';

const props = defineProps<{
    promptConfigId: PromptConfig['id'];
    sessionId: SessionId;
    variableChainHash: SessionId;
}>();

const promptStatus = computed(() => {
    return PromptService.getPromptStatus(
        props.promptConfigId,
        props.sessionId,
        props.variableChainHash,
    );
});
</script>

<template>
    <TooltipProvider :delay-duration="150">
        <Tooltip>
            <TooltipTrigger as-child>
                <Badge class="h-5 rounded-sm hover:bg-secondary" variant="secondary">{{
                    upperFirst(promptStatus.status)
                }}</Badge>
            </TooltipTrigger>
            <TooltipContent>
                <p class="max-w-[240px] break-words">{{ promptStatus.description }}</p>
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
</template>
